import { combineEpics } from 'redux-observable'
import { Observable } from 'rxjs/Observable'

import { URL_CONST } from 'utils/urlConsts'
import { matchURL } from 'utils/urls'

import { epicsErrorHandler } from '../../../epics'
import { FETCH_SELECTED_COMPANY_DATA_ASYNC } from '../../PartnerOptions/constants'

import { fetchDataError, fetchDataSuccess } from './actions'
import { DATA_REQUEST_ASYNC, PAGINATE_CHANGE, SEARCH_CHANGE } from './constants'

const fetchDataEpic = (action$, store, { api }) =>
  action$
    .ofType(
      DATA_REQUEST_ASYNC.INITIATE,
      SEARCH_CHANGE,
      PAGINATE_CHANGE,
      FETCH_SELECTED_COMPANY_DATA_ASYNC.SUCCESS
    )
    .filter((action) => {
      if (action.type === FETCH_SELECTED_COMPANY_DATA_ASYNC.SUCCESS)
        return matchURL(URL_CONST.incidents.incidents)
      return true
    })
    .mergeMap((action) =>
      api.resolutionCenter
        .getServerScanData(
          action.payload.reportId,
          store.getState().partnerOptions.selectedCompany?.value
        )
        .map((response) => fetchDataSuccess(response))
        .catch((error) => Observable.of(epicsErrorHandler(fetchDataError, error)))
        .takeUntil(action$.ofType(DATA_REQUEST_ASYNC.CANCEL))
    )

export default combineEpics(fetchDataEpic)
